import { connect, ConnectedProps } from 'react-redux'
import { PaymentMethodsPayload } from '../../../../../../../../utils/reducers/payments/paymentMethods'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import TwinForm from '../../../../../../../../forms/TwinForm'
import { ModalSmallCentered } from '../../../../../../../../baseComponents/Modal'
import FormRenderer from '../../../../../../../../forms/FormRenderer'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { useCallback, useMemo, useState } from 'react'
import { addDictionaryExtraLine } from '../../../../../../../../utils/globals/dictionary'
import { SellOrderModelType } from '@teinor/erp/types/company/order/sell/sellOrder'
import { InputTableURLsTable, SetCompleteDataTy } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import { ButtonPrimary, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import { ModalEditComponentPropsWithoutSubmit } from '../../../../../../../../baseComponents/ModalsLayouts/types'

type ModalOrderPaymentMethodSimpleProps = ReduxModalOrderPaymentMethodSimple & ModalOrderPaymentMethodSimpleLogicProps & {
    orderURLs: InputTableURLsTable
    isReadOnly?: boolean
}

const ModalOrderPaymentMethodSimple: React.FC<ModalOrderPaymentMethodSimpleProps> = ({orderURLs, paymentMethods, setCompleteData, setOpened, allRowData,  isReadOnly}) => {
    const {t} = useTwinTranslation()
    const { dictPaymentMethods, handleOnSubmit, selectedPaymentMethodId, setSelectedPaymentMethodId } = useModalOrderPaymentMethodSimpleLogic({ paymentMethods, setCompleteData, setOpened, allRowData })
    
    const fields: FormRender<SellOrderModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'PaymentMethodId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('typeMethod', 'Tipo de método'),
                    items: dictPaymentMethods,
                    sortItems: true,
                    value: selectedPaymentMethodId || undefined,
                    onChange: (val) => setSelectedPaymentMethodId(val),
                    readOnly: isReadOnly
                },
                {
                    name: 'id',
                    value: allRowData?.id,
                    component: 'InputHidden',
                },
            ]
        }
    ]
    return (
        <ModalSmallCentered opened={true} setOpened={()=>setOpened(null)}>
            <h2><TwinTrans transKey='configSinglePaymentMethod'>Configurar método de pago</TwinTrans></h2>
            <TwinForm action={orderURLs.updateHeaderData} onSubmit={handleOnSubmit} className='mt-20 flex flex-auto flex-col notFlexAutoFormRender' >
                <FormRenderer sections={fields} />
                <div className='flex items-center gap-x-10 justify-center mt-auto'>
                    <ButtonSecondary onClick={() => setOpened(null)}>
                        <TwinTrans transKey='cancel'>Cancelar</TwinTrans>
                    </ButtonSecondary>
                    <ButtonPrimary disabled={isReadOnly}>
                        <TwinTrans transKey='save'>Guardar</TwinTrans>
                    </ButtonPrimary>
                </div>
            </TwinForm>
        </ModalSmallCentered>
    )
}

interface ModalOrderPaymentMethodSimpleLogicProps extends ModalEditComponentPropsWithoutSubmit {
    setCompleteData: SetCompleteDataTy
    paymentMethods: PaymentMethodsPayload
}

const useModalOrderPaymentMethodSimpleLogic = ({ paymentMethods, setCompleteData, setOpened, allRowData }: ModalOrderPaymentMethodSimpleLogicProps) => {
    const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState<number | null>(allRowData?.PaymentMethodId || null)

    const dictPaymentMethods = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(paymentMethods?.active || {}))), [paymentMethods])
    
    const handleOnSubmit: OnSubmit = useCallback(async (res, vals) => {
        const myPaymentMethod = dictPaymentMethods[vals.PaymentMethodId]
        setCompleteData((old)=>{
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld.header.PayMCopy ={id: myPaymentMethod.id, name: myPaymentMethod.name}
            return copyOld
        })
        setOpened(null)
    }, [setCompleteData, dictPaymentMethods, setOpened])
    return { dictPaymentMethods, handleOnSubmit, selectedPaymentMethodId, setSelectedPaymentMethodId }
}


const modalOrderPaymentMethodSimpleDispatch = {
    setPaymentMethods: (payload: PaymentMethodsPayload) => ({ type: 'CHANGE_PAYMENTMETHODS', payload }),
}

type ReduxModalOrderPaymentMethodSimple = ConnectedProps<typeof modalOrderPaymentMethodSimpleConnect>
const mapModalOrderPaymentMethodSimpleConnector = (state: AllReduxPayloads) => ({paymentMethods: state.paymentMethods })
const modalOrderPaymentMethodSimpleConnect = connect(mapModalOrderPaymentMethodSimpleConnector, modalOrderPaymentMethodSimpleDispatch)
const taskConnectLoading = withLoading(ModalOrderPaymentMethodSimple, [{ fetchUrl: '/api/app/config/payment/paymentMethod/getAllPaymentMethods', propName: 'paymentMethods', setFunctionName: 'setPaymentMethods' }])
const ModalOrderPaymentMethodSimpleConnect = modalOrderPaymentMethodSimpleConnect(taskConnectLoading)
export default ModalOrderPaymentMethodSimpleConnect